import { Control, Controller, FieldErrors } from "react-hook-form";
import { TextInput } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { ServiceFormValues } from "../../types";

interface ComponentProps {
  control: Control<ServiceFormValues>;
  errors?: FieldErrors<ServiceFormValues>;
  isItem?: boolean;
}

export const QuantityField = ({ control, errors, isItem }: ComponentProps) => {
  const { t } = useTranslations();

  if (!isItem) {
    return null;
  }

  return (
    <div className="w-full">
      <Controller
        control={control}
        name="quantity"
        rules={{
          validate: (value) => {
            if (!value) {
              return t({
                id: "inventory-item-form-page.mandatory-field",
                defaultMessage: "Mandatory field",
              });
            }
            if (Number(value) <= 0) {
              return t({
                id: "inventory-item-form-page.quantity-greater-than-zero",
                defaultMessage: "Quantity must be greater than zero",
              });
            }
            return true;
          },
        }}
        render={({ field: { value, onChange } }) => (
          <TextInput
            placeholder={t({
              id: "common.enter",
              defaultMessage: "Enter",
            })}
            onKeyDown={(e) => {
              const notAllowedCharacters = ["e", "E", "+", "-", "."];
              if (notAllowedCharacters.includes(e.key)) {
                e.preventDefault();
              }
            }}
            type="number"
            min={1}
            step={1}
            maxLength={8}
            isInvalid={!!errors?.quantity}
            label={t({
              id: "inventory-item-form-page.quantity",
              defaultMessage: "Quantity",
            })}
            onChange={(e) => {
              const numericValue = e.target.value.replace(/[^\d]/g, "");
              const truncatedValue = numericValue.slice(0, 8);
              onChange(truncatedValue);
            }}
            isRequired
            errorMessage={errors?.quantity?.message}
            value={value || ""}
          />
        )}
      />
    </div>
  );
};
